import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://uucputelxaotbcnmzrwm.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "sb_publishable_0S-rSMhH68vFoqs_NStrJQ_GZclbUdA";

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    // Mantém a sessão no sessionStorage para resistir a reloads (F5),
    // mas a sessão de login será perdida se a aba for fechada.
    persistSession: true,
    storage: window.sessionStorage,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export type AppRole = "admin" | "user";
